import React from "react";
import SectionHeader from "./SectionHeader";

const STEPS = [
  { n: "01", t: "Create the litigation", d: "Upload the show-cause notice, order or petition. Vedum extracts parties, dates, sections invoked and issues." },
  { n: "02", t: "Research with insight", d: "Ask your question. Review a cited brief plus trends, forum outcomes and a research map." },
  { n: "03", t: "Draft in the studio", d: "Select the authorities you trust and generate a structured, cited reply or submission to refine." },
  { n: "04", t: "Track until disposal", d: "Relevance alerts flag listings, rulings and law changes until the matter is decided." },
];

const Workflow = () => (
  <section id="workflow" className="vd-section vd-section--dark">
    <div className="container">
      <SectionHeader eyebrow="HOW IT WORKS" title="From notice to filing in four steps.">
        Vedum automates the slow, repetitive work so you stay in control of judgement and strategy.
      </SectionHeader>
      <div className="row g-4">
        {STEPS.map((s) => (
          <div className="col-md-6 col-lg-3" key={s.n}>
            <div className="vd-step">
              <div className="vd-step__n">{s.n}</div>
              <h3>{s.t}</h3>
              <p>{s.d}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Workflow;
